import contactbanner from "../images/contact_page_banner.jpg";
import contactBannerMob from "../images/contact_page_banner_mobile.jpg"
import Wrapper from "../components/wrapper/Wrapper";
import ContactForm from "../components/ContactForm";

const ContactPage = () => {
    return (
        <>
            <Wrapper
                showTopFooter={false}
                desktopImage={contactbanner}
                mobileImage={contactBannerMob}
                firstTitle="Let's connect"
                bannerHeading="Contact"
                bansubheading="We'd love to hear from you" >
                <ContactForm></ContactForm>
            </Wrapper>
        </>
    )
};


export default ContactPage;

